import { useEffect, useState } from "react";

import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeGooglePlacesAddress } from "@/__mocks__/mockBaseTypes";
import type { AddressFieldProps } from "@/ui/composed/form/AddressField";
import AddressField from "@/ui/composed/form/AddressField";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<AddressFieldProps> = {
  title: "Composed/Form/Address Field",
  component: AddressField,
  argTypes: {
    hasError: { control: "boolean" },
    isDisabled: { control: "boolean" },
    isRequired: { control: "boolean" },
    onChange: { action: "Changed" },
  },
  args: {
    hasError: false,
    isDisabled: false,
    isRequired: false,
    testID: "address",
  },

  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render(args) {
    const [value, setValue] = useState<GooglePlacesAddress | undefined>(
      args.value,
    );

    useEffect(() => {
      setValue(args.value);
    }, [args.value]);

    const onChange = (newValue: GooglePlacesAddress) => {
      setValue(newValue);
      args.onChange(newValue);
    };

    return (
      <Box width="100%">
        <AddressField {...args} onChange={onChange} value={value} />
      </Box>
    );
  },
};

type Story = StoryObj<AddressFieldProps>;

const Primary: Story = {};

const WithInitialValues: Story = {
  args: {
    value: {
      ...fakeGooglePlacesAddress({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        state: faker.location.state({ abbreviated: true }),
      }),
    },
  },
};

export { Primary, WithInitialValues };
export default StoryMeta;
